import React from 'react'
import { FieldArray } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import DateRangesFieldArray from 'app/domains/common/DateRangesFieldArray'
import { disableDays } from 'helpers'

import './styles.scss'
const baseClass = 'profile-out-of-office'

const ProfileOutOfOffice = ({ t, ...props }) => {
  return (
    <div className={`${baseClass}__dayoffs`}>
      <FieldArray
        name="dayoffs"
        component={DateRangesFieldArray}
        title={t('No Out of Office days are added')}
        btnText={t('Add new Out of Office days')}
        emptyBlockStretched={false}
        disableDays={disableDays}
        {...props}
      />
    </div>
  )
}

export default withTranslation('user')(ProfileOutOfOffice)
